import { render, staticRenderFns } from "./RenyuanModify.vue?vue&type=template&id=6506d7fd&scoped=true"
import script from "./RenyuanModify.vue?vue&type=script&lang=js"
export * from "./RenyuanModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506d7fd",
  null
  
)

export default component.exports